import React from "react";
import PropTypes from "prop-types";
import styles from "./TextSectionElement.module.css";
import parser from "html-react-parser";

/**
 * View component.
 * Displays HTML from the text editor.
 */
export function TextSectionElement({ text, align, textColor, width, size }) {
  const getRGBColor = (colorString) => {
    if (colorString) {
      // Extract the RGB value from the color string
      const match = colorString.match(/\b(?:rgb\(|rgba\().+?\)/);
      if (match) {
        return match[0]; // Return the extracted color value
      } else {
        return ""; // Return empty string if no valid color value is found
      }
    } else {
      return;
    }
  };

  const color = getRGBColor(textColor);
  // const width ?? width
  let fontSize = size;
  switch (size?.toLowerCase()) {
    case "small": {
      fontSize = "16px";
      break;
    }
    case "normal": {
      fontSize = "20px";
      break;
    }
    case "large": {
      fontSize = "22px";
      break;
    }
    case "header2": {
      fontSize = "26px";
      break;
    }
    case "header1": {
      fontSize = "30px";
      break;
    }
    default: {
      fontSize = "34px";
      break;
    }
  }

  return (
    <div
      style={{
        textAlign: align,
        color: color,
        fontSize: fontSize,
      }}
    >
      <div className={styles.textContent}>
        {text === "" ? (
          <>
            <p className={styles.defaultText}>NEW ELEMENT TEXT</p>
          </>
        ) : (
          parser(text)
        )}
      </div>
    </div>
  );
}

TextSectionElement.propTypes = {
  /**
   * HTML string to display.
   */
  text: PropTypes.string,
  /**
   * Object with preset styling for the text prop.
   */
  settings: PropTypes.shape({
    /**
     * String with color title and color.
     * Ex. 'default #fff'
     */
    textColor: PropTypes.string,
    customColor: PropTypes.string,
    align: PropTypes.oneOf(["left", "center", "right"]),
    fontSize: PropTypes.oneOf([
      "Small",
      "Normal",
      "Large",
      "Header2",
      "Header1",
    ]),
    width: PropTypes.oneOf([
      "Wide-xs",
      "Wide-sm",
      "Wide-md",
      "Wide-lg",
      "Normal",
    ]),
  }),
};

TextSectionElement.defaultProps = {
  settings: {
    textColor: "--color-b #000000",
    customColor: "#fff",
    align: "left",
    fontSize: "Normal",
    width: "Normal",
  },
};
